import classNames from 'classnames';
import { SimpleTitle } from 'shared/components/page-with-settings';
import { SettingsContainerTitleProps } from 'shared/components/page-with-settings/components/SettingsContainer';
import { EtfLabel } from 'shared/ui-kit';
import styles from './settings-title.module.scss';

export interface EtfPageSettingsTitleProps extends SettingsContainerTitleProps {
	ticker: string;
	shortDescription: string;
}
export const EtfPageSettingsTitle = (props: EtfPageSettingsTitleProps) => {
	if (props.isExpanded) {
		return (
			<div className={classNames(styles.expanded, "flex-container-horizontal")}>
				<a className={classNames("flex-size-least", styles.nav)} href="#" onClick={() => props.setIsExpanded(false)}>
					<i className="fa fa-chevron-left"></i>
				</a>
				<div className={classNames(styles.desc, )}>
					<div>
						<EtfLabel ticker={props.ticker} />
					</div>
					<div className={styles.help}>
						{props.shortDescription}
					</div>
				</div>
			</div>
		)
	}
	else {
		return <SimpleTitle {...props} text={props.ticker} />
	}
}